import styled from 'styled-components'
import { colors } from '@120wateraudit/envirio-components'

const DetailsLabel = styled.label`
  color: ${colors.black};
  opacity: 0.5;
`

export default DetailsLabel
